export default __webpack_public_path__ + "static/05.color_story-758b093da96b5631e121a7ba9b181b9b.svg";